import { InformationEquipmentListCard } from 'app/components/equipment';
import { formatDisplayName } from '../formatDisplayName';
import { ReactComponent as PendingReceivedIcon } from 'assets/images/pending-received.svg';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Invitation } from 'services/api/invitations/types';

interface Props {
  className?: string;
  invitations: Invitation[];
}

export default function PendingReceivedInvitationsEquipmentListCard({
  className,
  invitations,
}: Props) {
  const { t } = useTranslation();

  const items = useMemo(
    () =>
      invitations
        .slice(0, 2)
        .map(
          ({
            sharedItemDetails: { ownerName, ownerEmail, sharedItemLabel },
          }) => ({
            i18nKey:
              'access_sharing.equipment_list.invitations.granted_access_to',
            values: {
              name: formatDisplayName(ownerName, ownerEmail),
              to: sharedItemLabel,
            },
          }),
        ),
    [invitations],
  );

  if (!items.length) {
    return null;
  }

  return (
    <InformationEquipmentListCard
      icon={PendingReceivedIcon}
      title={t(
        'access_sharing.equipment_list.invitations.pending-received.title',
      )}
      items={items}
      className={className}
      link={items.length >= 1 ? '/access/pending-invitations' : undefined}
      linkLabel={t(
        'access_sharing.equipment_list.invitations.pending-received.link',
      )}
    />
  );
}
